/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var FormatSpecifier = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(FormatSpecifier, _super);
    function FormatSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormatSpecifier.prototype.a = function () {
        return null;
    };
    FormatSpecifier.$t = markType(FormatSpecifier, 'FormatSpecifier');
    return FormatSpecifier;
}(Base));
export { FormatSpecifier };
//# sourceMappingURL=FormatSpecifier.js.map
